/* Ecstasy virtual try-on.
   - Face tracking: MediaPipe Face Landmarker, in the browser. Nothing is uploaded.
   - True-to-scale: the iris is ~11.7 mm across on almost every adult, so it gives a mm-per-pixel ruler.
     The frame is drawn at its real width (2 x lens + bridge + rims) when the product has measurements.
   - Frame art: the product's front-view photo, background cut away on the fly; clear lenses become see-through. */
(function () {
  'use strict';
  var D = window.ECX_TRYON || null;            // product page data; cards load their product on demand

  var MP = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14';
  var MODEL = 'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task';
  var IRIS_MM = 11.7;

  /* ---------- helpers ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  var ICON = {
    cam: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 8h3l2-2.5h6L17 8h3v11H4z"/><circle cx="12" cy="13.5" r="3.5"/></svg>',
    face: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 8V5a1 1 0 0 1 1-1h3M16 4h3a1 1 0 0 1 1 1v3M20 16v3a1 1 0 0 1-1 1h-3M8 20H5a1 1 0 0 1-1-1v-3"/><circle cx="9" cy="11" r="1.6"/><circle cx="15" cy="11" r="1.6"/><path d="M10.6 11h2.8M9.5 15.5c1.4 1 3.6 1 5 0"/></svg>',
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    up: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16V4M7 9l5-5 5 5M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/></svg>'
  };

  /* ---------- frame measurements (mm) from the spec list or "Size 52-18-140" ---------- */
  function sizeFrom(txt) {
    var L = 0, B = 0, T = 0;
    var m = txt.match(/Lens\s*width[^0-9]{0,20}(\d{2})/i); if (m) L = +m[1];
    m = txt.match(/Bridge[^0-9]{0,20}(\d{2})/i); if (m) B = +m[1];
    m = txt.match(/(?:Temple|Arm\s*Length)[^0-9]{0,20}(\d{3})/i); if (m) T = +m[1];
    if (!L) { m = txt.match(/\b(4\d|5\d|6\d)\s*[-–□]\s*(1\d|2\d)\s*[-–]\s*(1[2-5]\d)\b/); if (m) { L = +m[1]; B = +m[2]; T = +m[3]; } }
    return L && B ? [L, B, T] : null;
  }
  function frameSize() {
    if (D && D.size !== undefined) return D.size;
    if (window.__ecxSize && window.__ecxSize[0]) return window.__ecxSize;
    return sizeFrom(document.body.innerText || '');
  }

  /* ---------- cut the frame out of its product photo ---------- */
  var cutCache = {};
  function loadImg(src) {
    return new Promise(function (res, rej) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); }; im.onerror = rej;
      im.src = src.indexOf('//') === 0 ? 'https:' + src : src;
    });
  }
  function cutout(src) {
    if (cutCache[src]) return cutCache[src];
    cutCache[src] = loadImg(src).then(function (im) {
      var W = 900, H = Math.round(W * im.naturalHeight / im.naturalWidth);
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.fillStyle = '#fff'; x.fillRect(0, 0, W, H); x.drawImage(im, 0, 0, W, H);
      var id = x.getImageData(0, 0, W, H), d = id.data, N = W * H;
      // near-white mask (background, clear lens, highlights)
      var white = new Uint8Array(N);
      for (var i = 0; i < N; i++) {
        var r = d[i * 4], g = d[i * 4 + 1], b = d[i * 4 + 2], mn = Math.min(r, g, b), mx = Math.max(r, g, b);
        if (mn > 222 && mx - mn < 22) white[i] = 1;
      }
      // background = near-white connected to the border
      var lab = new Int32Array(N), q = new Int32Array(N), qs, qe, comp = 1, comps = [];
      function flood(start, id) {
        qs = 0; qe = 0; q[qe++] = start; lab[start] = id; var cnt = 0, sx = 0, sy = 0, touches = false;
        while (qs < qe) {
          var p = q[qs++], px = p % W, py = (p / W) | 0; cnt++; sx += px; sy += py;
          if (px === 0 || py === 0 || px === W - 1 || py === H - 1) touches = true;
          if (px > 0 && white[p - 1] && !lab[p - 1]) { lab[p - 1] = id; q[qe++] = p - 1; }
          if (px < W - 1 && white[p + 1] && !lab[p + 1]) { lab[p + 1] = id; q[qe++] = p + 1; }
          if (py > 0 && white[p - W] && !lab[p - W]) { lab[p - W] = id; q[qe++] = p - W; }
          if (py < H - 1 && white[p + W] && !lab[p + W]) { lab[p + W] = id; q[qe++] = p + W; }
        }
        return { id: id, n: cnt, cx: sx / cnt, cy: sy / cnt, border: touches };
      }
      for (i = 0; i < N; i++) if (white[i] && !lab[i]) comps.push(flood(i, comp++));
      var bgIds = {}, lensIds = {}, lenses = [];
      comps.forEach(function (k) {
        if (k.border) bgIds[k.id] = 1;
        else if (k.n > N * 0.006) { lensIds[k.id] = 1; lenses.push(k); }
      });
      // alpha: background clear, clear lenses a faint glass tint, everything else solid with soft edges
      var minx = W, miny = H, maxx = 0, maxy = 0;
      for (i = 0; i < N; i++) {
        var a = 255, L = lab[i];
        if (L && bgIds[L]) a = 0;
        else if (L && lensIds[L]) a = 26;
        else {
          var rr = d[i * 4], gg = d[i * 4 + 1], bb = d[i * 4 + 2], m2 = Math.min(rr, gg, bb), M2 = Math.max(rr, gg, bb), lum = 0.3 * rr + 0.59 * gg + 0.11 * bb;
          if (m2 > 185 && M2 - m2 < 30) a = Math.max(0, Math.min(255, (255 - m2) * 2.2)); // pale greys: soft shadows and reflections fade out
          else if (lum > 150 && M2 - m2 < 40) a = Math.max(70, Math.min(255, 255 - (lum - 150) * 1.7)); // light, low-colour areas are lens: see-through, tinted
          var px2 = i % W, py2 = (i / W) | 0;
          if (a > 90) { if (px2 < minx) minx = px2; if (px2 > maxx) maxx = px2; if (py2 < miny) miny = py2; if (py2 > maxy) maxy = py2; }
        }
        d[i * 4 + 3] = a;
      }
      // keep only the frame: solid components at least 4% the size of the biggest one
      var lab2 = new Int32Array(N), sizes = [0], idn = 0;
      for (i = 0; i < N; i++) if (d[i * 4 + 3] > 40 && !lab2[i]) {
        idn++; var cnt2 = 0; qs = 0; qe = 0; q[qe++] = i; lab2[i] = idn;
        while (qs < qe) { var pp = q[qs++], px3 = pp % W; cnt2++;
          if (px3 > 0 && !lab2[pp - 1] && d[(pp - 1) * 4 + 3] > 40) { lab2[pp - 1] = idn; q[qe++] = pp - 1; }
          if (px3 < W - 1 && !lab2[pp + 1] && d[(pp + 1) * 4 + 3] > 40) { lab2[pp + 1] = idn; q[qe++] = pp + 1; }
          if (pp >= W && !lab2[pp - W] && d[(pp - W) * 4 + 3] > 40) { lab2[pp - W] = idn; q[qe++] = pp - W; }
          if (pp < N - W && !lab2[pp + W] && d[(pp + W) * 4 + 3] > 40) { lab2[pp + W] = idn; q[qe++] = pp + W; } }
        sizes.push(cnt2);
      }
      var big = Math.max.apply(null, sizes);
      minx = W; miny = H; maxx = 0; maxy = 0;
      for (i = 0; i < N; i++) {
        if (lab2[i] && sizes[lab2[i]] < big * 0.04) d[i * 4 + 3] = 0;
        if (d[i * 4 + 3] > 90) { var px4 = i % W, py4 = (i / W) | 0; if (px4 < minx) minx = px4; if (px4 > maxx) maxx = px4; if (py4 < miny) miny = py4; if (py4 > maxy) maxy = py4; }
      }
      if (maxx <= minx) throw new Error('empty');
      // front-view check: left/right mirror symmetry of the solid shape + wide aspect
      var inter = 0, uni = 0;
      for (var yy = miny; yy <= maxy; yy += 2) for (var xx = minx; xx <= maxx; xx += 2) {
        var p1 = yy * W + xx, p2 = yy * W + (minx + maxx - xx);
        var s1 = d[p1 * 4 + 3] > 120, s2 = d[p2 * 4 + 3] > 120;
        if (s1 && s2) inter++; if (s1 || s2) uni++;
      }
      var bw = maxx - minx + 1, bh = maxy - miny + 1, sym = uni ? inter / uni : 0, asp = bw / bh;
      x.putImageData(id, 0, 0);
      var pad = 4, out = document.createElement('canvas');
      out.width = bw + pad * 2; out.height = bh + pad * 2;
      out.getContext('2d').drawImage(c, minx - pad, miny - pad, out.width, out.height, 0, 0, out.width, out.height);
      // lens centres (for clear lenses) else typical positions
      lenses.sort(function (a, b) { return b.n - a.n; });
      var lc = lenses.slice(0, 2).sort(function (a, b) { return a.cx - b.cx; });
      var lensY = 0.46, lx1 = 0.27, lx2 = 0.73;
      if (lc.length === 2) {
        lx1 = (lc[0].cx - minx + pad) / out.width; lx2 = (lc[1].cx - minx + pad) / out.width;
        lensY = ((lc[0].cy + lc[1].cy) / 2 - miny + pad) / out.height;
      }
      // temple colour: average of the solid pixels at the outer edges (end pieces / hinges)
      var od = out.getContext('2d').getImageData(0, 0, out.width, out.height).data, tr = 0, tg = 0, tb = 0, tn = 0, ew = Math.max(3, Math.round(out.width * 0.05));
      for (var yy2 = 0; yy2 < out.height; yy2++) for (var xs = 0; xs < 2; xs++) for (var xx2 = 0; xx2 < ew; xx2++) {
        var X2 = xs ? out.width - 1 - xx2 : xx2, k2 = (yy2 * out.width + X2) * 4;
        if (od[k2 + 3] > 200) { tr += od[k2]; tg += od[k2 + 1]; tb += od[k2 + 2]; tn++; }
      }
      var temple = tn ? 'rgb(' + Math.round(tr / tn) + ',' + Math.round(tg / tn) + ',' + Math.round(tb / tn) + ')' : '#303840';
      // hinge height: highest solid pixel row band at the outer edges
      var hingeY = 0.3;
      for (var yy3 = 0; yy3 < out.height; yy3++) { var k3 = (yy3 * out.width + 2) * 4, k4 = (yy3 * out.width + out.width - 3) * 4; if (od[k3 + 3] > 150 || od[k4 + 3] > 150) { hingeY = yy3 / out.height + 0.06; break; } }
      return { canvas: out, w: out.width, h: out.height, sym: sym, asp: asp, front: sym >= 0.62 && asp >= 1.7, lensY: lensY, lx1: lx1, lx2: lx2, src: src, temple: temple, hingeY: hingeY };
    });
    return cutCache[src];
  }

  /* best front photo for a variant: its own photo first, then the product's other photos */
  function frameFor(variantId) {
    var v = D.variants.filter(function (x) { return x.id === variantId; })[0];
    var list = [];
    if (v && v.img) list.push(v.img);
    D.images.forEach(function (im) { if (im.v.indexOf(variantId) > -1 && list.indexOf(im.src) < 0) list.push(im.src); });
    // the variant's photo run: images after its featured image until the next variant's featured image
    var start = v && v.img ? D.images.map(function (i) { return i.src; }).indexOf(v.img) : -1;
    if (start > -1) for (var k = start + 1; k < D.images.length && k < start + 6; k++) {
      if (D.images[k].v.length > 1) break;
      if (list.indexOf(D.images[k].src) < 0) list.push(D.images[k].src);
    }
    D.images.forEach(function (im) { if (list.indexOf(im.src) < 0) list.push(im.src); });
    list = list.slice(0, 8);
    var best = null;
    return list.reduce(function (p, src) {
      return p.then(function () {
        if (best && best.front && best.sym > 0.8) return;
        return cutout(src).then(function (f) {
          var score = (f.front ? 1 : 0) + f.sym * 0.6;
          if (!best || score > best._s) { f._s = score; best = f; }
        }, function () {});
      });
    }, Promise.resolve()).then(function () { return best && best.front ? best : null; });
  }

  /* ---------- face tracking ---------- */
  var vision = null, lmVideo = null, lmImage = null;
  function loadVision() {
    if (vision) return vision;
    // loaded through a module <script> tag: Shopify's asset minifier rewrites a bare dynamic import
    vision = new Promise(function (res, rej) {
      if (window.__ecxMP) return res(window.__ecxMP);
      var sc = document.createElement('script'); sc.type = 'module';
      sc.textContent = 'import * as m from "' + MP + '/vision_bundle.mjs"; window.__ecxMP = m; window.dispatchEvent(new Event("ecxmp"));';
      window.addEventListener('ecxmp', function () { res(window.__ecxMP); }, { once: true });
      sc.onerror = rej; document.head.appendChild(sc);
      setTimeout(function () { if (!window.__ecxMP) rej(new Error('timeout')); }, 30000);
    }).then(function (m) {
      return m.FilesetResolver.forVisionTasks(MP + '/wasm').then(function (fs) { return { m: m, fs: fs }; });
    });
    return vision;
  }
  function landmarker(mode) {
    return loadVision().then(function (v) {
      var opts = { baseOptions: { modelAssetPath: MODEL, delegate: 'GPU' }, runningMode: mode, numFaces: 1, outputFacialTransformationMatrixes: true };
      return v.m.FaceLandmarker.createFromOptions(v.fs, opts).catch(function () {
        opts.baseOptions.delegate = 'CPU'; return v.m.FaceLandmarker.createFromOptions(v.fs, opts);
      });
    });
  }

  /* pose from landmarks (normalised coords, already mirrored if needed) */
  function pose(lm, W, H, mirror) {
    function P(i) { var p = lm[i]; return { x: (mirror ? 1 - p.x : p.x) * W, y: p.y * H, z: p.z * W }; }
    var rI = P(468), lI = P(473);                       // iris centres
    var irisD = Math.max((Math.hypot(P(469).x - P(471).x, P(469).y - P(471).y) + Math.hypot(P(474).x - P(476).x, P(474).y - P(476).y)) / 2,
                         (Math.hypot(P(470).x - P(472).x, P(470).y - P(472).y) + Math.hypot(P(475).x - P(477).x, P(475).y - P(477).y)) / 2);
    var a = P(234), b = P(454);                          // face sides at eye level
    var nose = P(1), mid = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
    var faceW = Math.hypot(b.x - a.x, b.y - a.y);
    var left = rI.x < lI.x ? rI : lI, right = rI.x < lI.x ? lI : rI;
    var roll = Math.atan2(right.y - left.y, right.x - left.x);
    var yaw = Math.max(-0.9, Math.min(0.9, Math.asin(Math.max(-1, Math.min(1, ((nose.x - mid.x) * Math.cos(roll) + (nose.y - mid.y) * Math.sin(roll)) / (faceW / 2))))));
    var pitch = (nose.y - (left.y + right.y) / 2) / faceW;  // only used for a small vertical nudge
    return { cx: (left.x + right.x) / 2, cy: (left.y + right.y) / 2, pd: Math.hypot(right.x - left.x, right.y - left.y), roll: roll, yaw: yaw, pitch: pitch, ppm: irisD / IRIS_MM, faceW: faceW };
  }

  /* one-euro style smoothing: steady when still, quick when moving */
  function Smooth() { this.s = null; }
  Smooth.prototype.f = function (p) {
    if (!this.s) { this.s = Object.assign({}, p); return this.s; }
    var s = this.s, move = Math.hypot(p.cx - s.cx, p.cy - s.cy) / Math.max(p.pd, 1);
    var k = Math.min(0.85, 0.22 + move * 6);
    ['cx', 'cy', 'pd', 'roll', 'yaw', 'pitch', 'ppm', 'faceW'].forEach(function (key) { s[key] += (p[key] - s[key]) * (key === 'ppm' || key === 'faceW' ? 0.08 : k); });
    return s;
  };

  /* draw the frame on the face */
  function drawFrame(ctx, f, ps, adj, size) {
    if (!f || !ps) return;
    var framePx;
    if (size) framePx = (size[0] * 2 + size[1] + 8) * ps.ppm;                 // true size from measurements
    else framePx = (ps.pd / ((f.lx2 - f.lx1) || 0.46)) ;                      // no measurements: lens centres on pupils
    framePx *= adj.scale;
    var s = framePx / f.w, w = f.w * s, h = f.h * s;
    var cxImg = (f.lx1 + f.lx2) / 2 * w;
    ctx.save();
    ctx.translate(ps.cx, ps.cy + adj.dy * ps.pd + ps.pd * 0.02);
    ctx.rotate(ps.roll);
    ctx.translate(Math.sin(ps.yaw) * ps.pd * 0.18, 0);
    ctx.scale(Math.cos(ps.yaw * 0.9), 1);
    ctx.shadowColor = 'rgba(20,25,33,.28)'; ctx.shadowBlur = Math.max(4, w * 0.012); ctx.shadowOffsetY = Math.max(2, w * 0.008);
    ctx.drawImage(f.canvas, -cxImg, -f.lensY * h, w, h);
    ctx.restore();
  }


  /* ---------- 3D: the frame rebuilt as a 3D object (curved front from the photo + temple arms) ---------- */
  var THREEP = null;
  function loadThree() {
    if (THREEP) return THREEP;
    THREEP = new Promise(function (res, rej) {
      if (window.__ecxTHREE) return res(window.__ecxTHREE);
      var sc = document.createElement('script'); sc.type = 'module';
      sc.textContent = 'import * as T from "https://esm.sh/three@0.160.0"; import { GLTFLoader } from "https://esm.sh/three@0.160.0/examples/jsm/loaders/GLTFLoader.js"; import { RoomEnvironment } from "https://esm.sh/three@0.160.0/examples/jsm/environments/RoomEnvironment.js"; window.__ecxTHREE = Object.assign({ GLTFLoader: GLTFLoader, RoomEnvironment: RoomEnvironment }, T); window.dispatchEvent(new Event("ecxthree"));';
      window.addEventListener('ecxthree', function () { res(window.__ecxTHREE); }, { once: true });
      sc.onerror = rej; document.head.appendChild(sc);
      setTimeout(function () { if (!window.__ecxTHREE) rej(new Error('three timeout')); }, 20000);
    });
    return THREEP;
  }
  var G3 = null;
  function make3D(T, host) {
    var cv = document.createElement('canvas'); cv.className = 'ecx-to__gl';
    host.insertBefore(cv, host.querySelector('.ecx-to__guide'));
    var r;
    try { r = new T.WebGLRenderer({ canvas: cv, alpha: true, antialias: true, preserveDrawingBuffer: true }); } catch (e) { cv.remove(); return null; }
    r.setPixelRatio(1); r.outputColorSpace = T.SRGBColorSpace; r.toneMapping = T.NeutralToneMapping;
    var scene = new T.Scene();
    try { scene.environment = new T.PMREMGenerator(r).fromScene(new T.RoomEnvironment(), 0.04).texture; } catch (e) {}
    var cam = new T.OrthographicCamera(-1, 1, 1, -1, -20000, 20000); cam.position.z = 10000;
    scene.add(new T.HemisphereLight(0xffffff, 0x99a0a8, 1.4));
    var dl = new T.DirectionalLight(0xffffff, 1.6); dl.position.set(0.4, 0.8, 1); scene.add(dl);
    var g = new T.Group(); scene.add(g);
    var api = { T: T, r: r, scene: scene, cam: cam, g: g, cv: cv, key: '' };
    api.size = function (w, h) { r.setSize(w, h, false); cam.left = -w / 2; cam.right = w / 2; cam.top = h / 2; cam.bottom = -h / 2; cam.updateProjectionMatrix(); api.w = w; api.h = h; };
    api.build = function (f, size, faceMm, adj) {
      var key = 'p|' + f.src + '|' + (size || []).join() + '|' + Math.round((faceMm || 0) / 4) + '|' + adj.scale;
      if (key === api.key) return; api.key = key;
      while (g.children.length) { var o = g.children.pop(); o.traverse && o.traverse(function (m) { if (m.geometry) m.geometry.dispose(); if (m.material) m.material.dispose(); }); }
      var pdGuess = 63;
      var W = (size ? size[0] * 2 + size[1] + 8 : pdGuess / ((f.lx2 - f.lx1) || 0.46)) * adj.scale;
      var H = W * f.h / f.w, R = W * 1.35, z0 = 11; api.W = W;
      // curved front: the product photo on a gently wrapped surface
      var geo = new T.PlaneGeometry(W, H, 32, 1), pos = geo.attributes.position;
      for (var i = 0; i < pos.count; i++) { var x = pos.getX(i); pos.setZ(i, -(x * x) / (2 * R)); }
      geo.computeVertexNormals();
      var tex = new T.CanvasTexture(f.canvas); tex.colorSpace = T.SRGBColorSpace; tex.anisotropy = 4;
      var front = new T.Mesh(geo, new T.MeshBasicMaterial({ map: tex, transparent: true, alphaTest: 0.03, side: T.DoubleSide, depthWrite: false, toneMapped: false }));
      front.position.set((0.5 - (f.lx1 + f.lx2) / 2) * W, (f.lensY - 0.5) * H, z0); front.renderOrder = 3;
      g.add(front);
      // temple arms: from the hinges back to the ears, coloured from the frame's end pieces
      var L = (size && size[2]) || 140, face = faceMm || W * 0.95;
      var hx = W / 2 - 2.5, ex = face / 2 - 2, hz = z0 - (hx * hx) / (2 * R), hy = front.position.y + (0.5 - f.hingeY) * H;
      var mat = new T.MeshStandardMaterial({ color: new T.Color(f.temple), roughness: 0.45, metalness: 0.35 });
      [-1, 1].forEach(function (sd) {
        var arm = new T.Group(); arm.position.set(sd * hx, hy, hz);
        var bl = L * 0.72;                         // hinge to the top of the ear, then the tip curls down behind it
        var bar = new T.Mesh(new T.CapsuleGeometry(1.3, bl, 4, 10), mat); bar.rotation.x = Math.PI / 2; bar.scale.set(0.8, 1, 1.35); bar.position.z = -bl / 2;
        var tl = L * 0.24, tip = new T.Mesh(new T.CapsuleGeometry(1.2, tl, 4, 10), mat);
        tip.rotation.x = Math.PI / 2 - 0.6; tip.scale.set(0.8, 1, 1.3); tip.position.set(0, -Math.sin(0.6) * tl / 2, -bl - Math.cos(0.6) * tl / 2);
        arm.add(bar); arm.add(tip);
        arm.rotation.y = sd * Math.atan2(hx - ex, L) * -1; arm.rotation.x = -0.06;
        arm.renderOrder = 2; g.add(arm);
      });
      // invisible head: hides the arms where they go behind the head or ears
      var head = new T.Mesh(new T.SphereGeometry(1, 32, 20), new T.MeshBasicMaterial({ colorWrite: false }));
      head.scale.set(face / 2 + 3, face * 0.8, 100); head.position.set(0, -12, -86); head.renderOrder = 1;
      api.head = head; g.add(head);
    };
    /* a real 3D model (made from the product photos): scaled to the frame's true width, lens centre at the origin */
    var models = {};
    api.buildModel = function (url, size, faceMm, adj, f) {
      var key = 'm|' + url + '|' + (size || []).join() + '|' + Math.round((faceMm || 0) / 4) + '|' + adj.scale;
      if (key === api.key) return true;
      if (!models[url]) {
        models[url] = 'loading';
        new T.GLTFLoader().load(url, function (gl) { models[url] = gl.scene; api.key = ''; window.dispatchEvent(new Event('ecxmodel')); }, null, function () { models[url] = 'error'; });
        return false;
      }
      if (models[url] === 'loading' || models[url] === 'error') return false;
      api.key = key;
      while (g.children.length) g.remove(g.children[g.children.length - 1]);
      var src = models[url], o = src.clone(true), box = new T.Box3().setFromObject(o), sz = box.getSize(new T.Vector3());
      // front part = the slice nearest the viewer; its width is the frame width, its centre the lens line
      var front = new T.Box3(), v = new T.Vector3(), zCut = box.max.z - sz.z * 0.12;
      o.updateMatrixWorld(true);
      o.traverse(function (m) { if (!m.isMesh) return; var pa = m.geometry.attributes.position; for (var i = 0; i < pa.count; i += 3) { v.fromBufferAttribute(pa, i).applyMatrix4(m.matrixWorld); if (v.z >= zCut) front.expandByPoint(v); } });
      if (front.isEmpty()) front = box;
      var fw = front.max.x - front.min.x, W = (size ? size[0] * 2 + size[1] + 8 : 135) * adj.scale, k = W / fw;
      var c = front.getCenter(new T.Vector3());
      var holder = new T.Group(); holder.add(o); o.position.set(-c.x, -(c.y + (front.max.y - front.min.y) * 0.04), -front.max.z);
      holder.scale.setScalar(k); holder.position.z = 13; holder.renderOrder = 2; g.add(holder); api.W = W;
      var face = faceMm || W * 0.95;
      var head = new T.Mesh(new T.SphereGeometry(1, 32, 20), new T.MeshBasicMaterial({ colorWrite: false }));
      head.scale.set(face / 2 + 7, face * 0.85, 104); head.position.set(0, -8, -88); head.renderOrder = 1; api.head = head; g.add(head);
      return true;
    };
    api.draw = function (hp) {
      g.visible = !!hp; api.head.visible = true;
      if (hp) {
        g.position.set(hp.o[0], hp.o[1], hp.o[2]);
        var m = new T.Matrix4().makeBasis(new T.Vector3().fromArray(hp.x), new T.Vector3().fromArray(hp.y), new T.Vector3().fromArray(hp.z));
        g.quaternion.setFromRotationMatrix(m); g.scale.setScalar(hp.ppm);
      }
      r.render(scene, cam);
    };
    var pcam = new T.PerspectiveCamera(24, 1, 1, 50000);
    api.spin = function (ry, rx) {                // 3D product viewer, with real perspective
      g.visible = true; api.head.visible = false;
      g.position.set(0, 0, 30); g.rotation.set(rx, ry, 0, 'YXZ'); g.scale.setScalar(1);
      var asp = api.w / api.h, t = Math.tan(pcam.fov * Math.PI / 360), Wm = api.W || 140;
      pcam.aspect = asp; pcam.position.set(0, 0, Math.max((Wm / 0.6) / (2 * t * asp), (Wm * 0.9) / (2 * t)));
      pcam.lookAt(0, 0, 0); pcam.updateProjectionMatrix();
      r.render(scene, pcam);
    };
    api.clear = function () { g.visible = false; r.render(scene, cam); };
    return api;
  }
  function ensure3D() {
    if (G3) return Promise.resolve(G3);
    return loadThree().then(function (T) { G3 = G3 || make3D(T, ui.canvas.parentElement); if (G3) { G3.size(ui.canvas.width, ui.canvas.height); setTimeout(redrawPhoto, 0); } return G3; }, function () { return null; });
  }

  /* head pose in 3D from landmarks; world = canvas pixels centred, y up, z toward the viewer */
  function v3(a) { return a; }
  function sub(a, b) { return [a[0] - b[0], a[1] - b[1], a[2] - b[2]]; }
  function dot(a, b) { return a[0] * b[0] + a[1] * b[1] + a[2] * b[2]; }
  function nrm(a) { var l = Math.hypot(a[0], a[1], a[2]) || 1; return [a[0] / l, a[1] / l, a[2] / l]; }
  function crs(a, b) { return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]]; }
  function head3(lm, rc, cw, ch, mirror) {
    function P(i) { var p = lm[i]; return [rc.x + (mirror ? 1 - p.x : p.x) * rc.w - cw / 2, ch / 2 - (rc.y + p.y * rc.h), -p.z * rc.w]; }
    var e1 = P(33), e2 = P(263), a = e1[0] < e2[0] ? e1 : e2, b = e1[0] < e2[0] ? e2 : e1;
    var x = nrm(sub(b, a)), up = sub(P(10), P(152)), y = nrm(sub(up, [x[0] * dot(up, x), x[1] * dot(up, x), x[2] * dot(up, x)])), z = crs(x, y);
    if (z[2] < 0) { z = [-z[0], -z[1], -z[2]]; y = crs(z, x); }
    var i1 = P(468), i2 = P(473), o = [(i1[0] + i2[0]) / 2, (i1[1] + i2[1]) / 2, (i1[2] + i2[2]) / 2];
    var irisD = Math.max((Math.hypot.apply(null, sub(P(469), P(471))) + Math.hypot.apply(null, sub(P(474), P(476)))) / 2,
                         (Math.hypot.apply(null, sub(P(470), P(472))) + Math.hypot.apply(null, sub(P(475), P(477)))) / 2);
    var ppm = irisD / IRIS_MM, faceMm = Math.hypot.apply(null, sub(P(454), P(234))) / ppm;
    return { o: o, x: x, y: y, z: z, ppm: ppm, face: Math.max(112, Math.min(162, faceMm)), yaw: Math.asin(Math.max(-1, Math.min(1, z[0]))) };
  }
  function Smooth3() { this.s = null; }
  Smooth3.prototype.f = function (p) {
    if (!this.s) { this.s = JSON.parse(JSON.stringify(p)); return this.s; }
    var s = this.s, move = Math.hypot(p.o[0] - s.o[0], p.o[1] - s.o[1]) / Math.max(p.ppm * 60, 1);
    var k = Math.min(0.9, 0.25 + move * 7), kr = Math.min(0.9, 0.3 + move * 7);
    for (var i = 0; i < 3; i++) { s.o[i] += (p.o[i] - s.o[i]) * k; s.x[i] += (p.x[i] - s.x[i]) * kr; s.y[i] += (p.y[i] - s.y[i]) * kr; }
    s.x = nrm(s.x); s.y = nrm(sub(s.y, s.x.map(function (c) { return c * dot(s.y, s.x); }))); s.z = crs(s.x, s.y);
    s.ppm += (p.ppm - s.ppm) * 0.1; s.yaw = p.yaw;
    if (Math.abs(p.yaw) < 0.3) s.face += (p.face - s.face) * 0.1;   // face width only learned while facing the camera
    return s;
  };

  /* fit verdict */
  function fit(ps, size) {
    if (!ps || !size) return null;
    var h = state.h3;
    if (h && Math.abs(h.yaw) > 0.3) return state.lastFit || null;
    var face = h ? h.face : ps.faceW / ps.ppm, frame = size[0] * 2 + size[1] + 8, d = frame - face;
    var v = Math.abs(d) <= 6 ? ['Great fit for your face', 0] : d < 0 ? (d < -12 ? ['Narrow for your face', 1] : ['Slightly narrow for your face', 1]) : (d > 12 ? ['Wide for your face', 1] : ['Slightly wide for your face', 1]);
    return (state.lastFit = { label: v[0], warn: v[1], face: Math.round(face), frame: Math.round(frame) });
  }

  /* ---------- UI ---------- */
  var ui = null, state = { variant: D ? D.current : null, frame: null, stream: null, mode: 'camera', running: false, ps: null, smooth: new Smooth(), adj: { scale: 1, dy: 0 }, photoImg: null, shots: [], sm3: new Smooth3(), h3: null, view: { ry: 0.5, rx: 0.12, drag: null, idle: 0 } };

  function build() {
    var root = el('div', 'ecx-to'); root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.setAttribute('aria-label', 'Virtual try-on');
    root.innerHTML =
      '<div class="ecx-to__box">' +
        '<div class="ecx-to__stage">' +
          '<video playsinline muted></video><canvas></canvas>' +
          '<div class="ecx-to__guide"></div><div class="ecx-to__flash"></div><div class="ecx-to__hint"></div>' +
          '<button type="button" class="ecx-to__close" aria-label="Close try-on">' + ICON.x + '</button>' +
          '<div class="ecx-to__gate"><div class="ecx-to__card"></div>' +
          '</div>' +
          '<div class="ecx-to__shot" hidden><img alt="Your try-on photo"><div class="ecx-to__row"><button type="button" class="ecx-to__btn" data-a="shotclose">Back</button><button type="button" class="ecx-to__btn ecx-to__btn--solid" data-a="save">Save photo</button></div></div>' +
        '</div>' +
        '<aside class="ecx-to__side">' +
          '<div><div class="ecx-to__eyebrow">Virtual try-on</div><h2 class="ecx-to__title"></h2></div>' +
          '<div class="ecx-to__colours"><p class="ecx-to__h">Colour</p><div class="ecx-to__sw"></div><div class="ecx-to__swname"></div></div>' +
          '<div class="ecx-to__fit" hidden><b><i></i><em style="font-style:normal"></em></b><span></span></div>' +
          '<div class="ecx-to__row ecx-to__live"><button type="button" class="ecx-to__btn ecx-to__btn--solid" data-a="snap">' + ICON.cam + 'Take photo</button></div>' +
          '<div class="ecx-to__photos"><p class="ecx-to__h">Your photos</p><div class="ecx-to__tray"></div></div>' +
          '<details class="ecx-to__more ecx-to__live"><summary class="ecx-to__link">Adjust the fit</summary><div class="ecx-to__adj" style="margin-top:12px">' +
            '<label>Size<input type="range" min="85" max="115" value="100" data-k="scale"></label>' +
            '<label>Height<input type="range" min="-12" max="12" value="0" data-k="dy"></label>' +
            '<button type="button" class="ecx-to__link" data-a="reset">Reset</button></div></details>' +
          '<div class="ecx-to__row ecx-to__view-only"><button type="button" class="ecx-to__btn ecx-to__btn--solid" data-a="tryon">' + ICON.face + 'Try on with your camera</button></div>' +
          '<button type="button" class="ecx-to__link" data-a="switch">Upload a photo instead</button>' +
          '<p class="ecx-to__note">Try-on is a guide. Lens tint and fine detail can look slightly different in person.</p>' +
        '</aside>' +
      '</div><input type="file" accept="image/*" hidden>';
    document.body.appendChild(root);
    ui = {
      root: root, video: $('video', root), canvas: $('canvas', root), ctx: $('canvas', root).getContext('2d'),
      gate: $('.ecx-to__gate', root), err: null, hint: $('.ecx-to__hint', root), guide: $('.ecx-to__guide', root),
      sw: $('.ecx-to__sw', root), swname: $('.ecx-to__swname', root), fit: $('.ecx-to__fit', root), tray: $('.ecx-to__tray', root),
      file: $('input[type=file]', root), shot: $('.ecx-to__shot', root), flash: $('.ecx-to__flash', root)
    };
    resetGate();
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-a]'); if (!a) return;
      var k = a.dataset.a;
      if (k === 'cam') startCamera();
      if (k === 'tryon') { stopView(); if (store('ecx-to-ok') === '1') startCamera(); else resetGate(); }
      if (k === 'upload' || k === 'switch') ui.file.click();
      if (k === 'snap') snap();
      if (k === 'shotclose') ui.shot.hidden = true;
      if (k === 'save') saveShot();
      if (k === 'reset') { state.adj = { scale: 1, dy: 0 }; root.querySelectorAll('[data-k]').forEach(function (r) { r.value = r.dataset.k === 'scale' ? 100 : 0; }); redrawPhoto(); }
    });
    $('.ecx-to__close', root).addEventListener('click', close);
    root.addEventListener('mousedown', function (e) { if (e.target === root) close(); });
    root.querySelectorAll('[data-k]').forEach(function (r) {
      r.addEventListener('input', function () { state.adj[r.dataset.k] = r.dataset.k === 'scale' ? r.value / 100 : r.value / 100; redrawPhoto(); });
    });
    ui.file.addEventListener('change', function () { if (ui.file.files[0]) usePhoto(ui.file.files[0]); ui.file.value = ''; });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && ui.root.classList.contains('is-open')) close(); });
    window.addEventListener('resize', fitCanvas);
  }

  function fill() {
    $('.ecx-to__title', ui.root).textContent = D.title;
    ui.sw.innerHTML = ''; ui.tray.innerHTML = ''; state.shots = [];
    var many = !D.single && D.variants.length > 1;
    $('.ecx-to__colours', ui.root).style.display = many ? '' : 'none';
    if (many) D.variants.forEach(function (v) {
      var b = el('button'); b.type = 'button'; b.title = v.t; b.setAttribute('aria-label', v.t); b.dataset.v = v.id;
      if (v.img) b.style.backgroundImage = 'url("' + v.img.replace(/width=\d+/, 'width=200') + '")';
      b.setAttribute('aria-pressed', v.id === state.variant ? 'true' : 'false');
      b.addEventListener('click', function () { pick(v.id); });
      ui.sw.appendChild(b);
    });
  }

  function setHint(t) { ui.hint.textContent = t || ''; }
  function fitCanvas() {
    if (!ui) return;
    var r = ui.canvas.parentElement.getBoundingClientRect(), dpr = Math.min(window.devicePixelRatio || 1, 2);
    ui.canvas.width = Math.round(r.width * dpr); ui.canvas.height = Math.round(r.height * dpr);
    if (G3) { G3.size(ui.canvas.width, ui.canvas.height); G3.key = ''; }
    redrawPhoto();
  }

  function pick(id) {
    state.variant = id;
    ui.sw.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', +b.dataset.v === id ? 'true' : 'false'); });
    var v = D.variants.filter(function (x) { return x.id === id; })[0];
    ui.swname.textContent = v && !D.single ? v.t : '';
    setHint('Loading this colour…');
    frameFor(id).then(function (f) {
      if (state.variant !== id) return;
      if (!f) { setHint('No front photo for this colour yet'); return; }
      state.frame = f; if (G3) G3.key = ''; setHint(state.ps ? '' : (state.mode === 'camera' ? 'Look straight at the camera' : '')); redrawPhoto();
      // sync the product page's own colour picker so "Add to cart" matches
      if (!D.page) return;
      var sel = document.querySelector('[data-value="' + (v ? v.t.replace(/"/g, '\\"') : '') + '"]');
      if (sel && !sel.classList.contains('active')) sel.click();
    });
  }

  /* "cover" placement of a source (video or photo) inside the canvas */
  function coverRect(sw, sh, cw, ch) { var s = Math.max(cw / sw, ch / sh), w = sw * s, h = sh * s; return { x: (cw - w) / 2, y: (ch - h) / 2, w: w, h: h }; }

  function startCamera() {
    ui.err.textContent = '';
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { ui.err.textContent = 'Your browser can’t open the camera here. Try uploading a photo instead.'; return; }
    store('ecx-to-ok', '1');
    ui.gate.querySelector('.ecx-to__card').innerHTML = '<div class="ecx-to__spin"></div><p style="margin:0">Starting your camera…</p>';
    state.mode = 'camera';
    Promise.all([
      navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user', width: { ideal: 1280 }, height: { ideal: 960 } }, audio: false }),
      state.lmV || (state.lmV = landmarker('VIDEO'))
    ]).then(function (r) {
      state.stream = r[0]; ui.video.srcObject = r[0];
      return ui.video.play().then(function () { return r[1]; });
    }).then(function (lm) {
      ui.gate.hidden = true; ui.root.classList.add('is-live'); fitCanvas(); state.running = true; setHint('Look straight at the camera'); loop(lm);
    }).catch(function (e) {
      resetGate();
      ui.err.textContent = e && e.name === 'NotAllowedError' ? 'Camera access was blocked. Allow it in your browser settings, or upload a photo instead.' : 'We couldn’t start the camera. You can upload a photo instead.';
    });
  }

  function loop(lm) {
    var lastT = -1;
    function tick() {
      if (!state.running) return;
      var v = ui.video, c = ui.canvas, ctx = ui.ctx;
      if (v.readyState >= 2) {
        var rc = coverRect(v.videoWidth, v.videoHeight, c.width, c.height);
        ctx.save(); ctx.translate(c.width, 0); ctx.scale(-1, 1); ctx.drawImage(v, rc.x, rc.y, rc.w, rc.h); ctx.restore();
        if (v.currentTime !== lastT) {
          lastT = v.currentTime;
          var res = lm.detectForVideo(v, performance.now());
          var face = res && res.faceLandmarks && res.faceLandmarks[0];
          if (face) {
            var p = pose(face, rc.w, rc.h, true); p.cx += c.width - rc.x - rc.w; p.cy += rc.y;
            state.ps = state.smooth.f(p); state.lost = 0;
            state.h3 = state.sm3.f(head3(face, { x: c.width - rc.x - rc.w, y: rc.y, w: rc.w, h: rc.h }, c.width, c.height, true));
          } else if (++state.lost > 8) { state.ps = null; state.h3 = null; state.smooth = new Smooth(); state.sm3 = new Smooth3(); }
        }
        if (state.ps && state.frame) { render(ctx); ui.guide.classList.add('is-off'); if (ui.hint.textContent === 'Look straight at the camera') setHint(''); }
        else if (G3) G3.clear();
        if (!state.ps || !state.frame) {}
        else { ui.guide.classList.remove('is-off'); if (!state.ps && state.frame) setHint('Look straight at the camera'); }
        showFit();
      }
      requestAnimationFrame(tick);
    }
    tick();
  }

  /* draw the frame: 3D when available, flat as a fallback */
  function render(ctx) {
    if (G3 && state.h3) {
      var h = state.h3, faceMm = h.face, d = state.adj.dy * 63 * h.ppm;
      if (!(D.model && G3.buildModel(D.model, frameSize(), faceMm, state.adj, state.frame))) G3.build(state.frame, frameSize(), faceMm, state.adj);
      G3.draw({ o: [h.o[0] + h.y[0] * d, h.o[1] + h.y[1] * d, h.o[2] + h.y[2] * d], x: h.x, y: h.y, z: h.z, ppm: h.ppm });
    } else drawFrame(ctx, state.frame, state.ps, state.adj, frameSize());
  }

  var fitT = 0;
  function showFit() {
    if (performance.now() - fitT < 500) return; fitT = performance.now();
    var f = fit(state.ps, frameSize());
    if (!f) { ui.fit.hidden = true; return; }
    ui.fit.hidden = false; ui.fit.classList.toggle('is-warn', !!f.warn);
    ui.fit.querySelector('em').textContent = f.label;
    ui.fit.querySelector('span').textContent = 'Frame ' + f.frame + ' mm wide. Your face about ' + f.face + ' mm. Measured from your eyes, so keep your face straight on.';
  }

  function usePhoto(file) {
    stopCamera(); state.mode = 'photo'; ui.err.textContent = '';
    var url = URL.createObjectURL(file), img = new Image();
    img.onload = function () {
      state.photoImg = img; ui.gate.hidden = true; ui.root.classList.add('is-live'); fitCanvas(); setHint('Finding your face…');
      (state.lmI || (state.lmI = landmarker('IMAGE'))).then(function (lm) {
        var r = lm.detect(img), face = r && r.faceLandmarks && r.faceLandmarks[0];
        state.photoFace = face || null;
        setHint(face ? '' : 'We couldn’t find a face. Try a clear, front-on photo.');
        redrawPhoto();
      }).catch(function () { setHint('Try-on couldn’t load. Please refresh and try again.'); });
    };
    img.src = url;
  }

  window.addEventListener('ecxmodel', function () { redrawPhoto(); });
  function redrawPhoto() {
    if (state.mode !== 'photo' || !state.photoImg || !ui) return;
    var c = ui.canvas, ctx = ui.ctx, im = state.photoImg;
    ctx.clearRect(0, 0, c.width, c.height);
    var s = Math.max(c.width / im.naturalWidth, c.height / im.naturalHeight), w = im.naturalWidth * s, h = im.naturalHeight * s, x = (c.width - w) / 2, y = (c.height - h) / 2;
    if (state.photoFace) {                       // keep the face centred when the photo is cropped to fill
      var fx = 0, fy = 0; [1, 468, 473].forEach(function (i) { fx += state.photoFace[i].x / 3; fy += state.photoFace[i].y / 3; });
      x = Math.min(0, Math.max(c.width - w, c.width / 2 - fx * w)); y = Math.min(0, Math.max(c.height - h, c.height * 0.45 - fy * h));
    }
    ctx.fillStyle = '#eef1f4'; ctx.fillRect(0, 0, c.width, c.height);
    ctx.drawImage(im, x, y, w, h);
    ui.guide.classList.add('is-off');
    if (state.photoFace) {
      var p = pose(state.photoFace, w, h, false); p.cx += x; p.cy += y; state.ps = p;
      state.h3 = head3(state.photoFace, { x: x, y: y, w: w, h: h }, c.width, c.height, false);
      if (state.frame) render(ctx); fitT = 0; showFit();
    }
  }

  function snap() {
    if (!state.ps || !state.frame) { setHint('Face the camera first'); return; }
    ui.flash.classList.remove('go'); void ui.flash.offsetWidth; ui.flash.classList.add('go');
    var comp = document.createElement('canvas'); comp.width = ui.canvas.width; comp.height = ui.canvas.height;
    var cx2 = comp.getContext('2d'); cx2.drawImage(ui.canvas, 0, 0); if (G3 && state.h3) cx2.drawImage(G3.cv, 0, 0);
    var url = comp.toDataURL('image/jpeg', 0.92);
    var v = D.variants.filter(function (x) { return x.id === state.variant; })[0];
    state.shots.unshift({ url: url, name: v && !D.single ? v.t : D.title });
    state.shots = state.shots.slice(0, 6);
    ui.tray.innerHTML = '';
    state.shots.forEach(function (s, i) {
      var a = el('a'); a.href = '#'; a.style.backgroundImage = 'url(' + s.url + ')'; a.setAttribute('aria-label', 'Open photo ' + (i + 1));
      a.appendChild(el('span', null, '')).textContent = s.name;
      a.addEventListener('click', function (e) { e.preventDefault(); openShot(i); });
      ui.tray.appendChild(a);
    });
    openShot(0);
  }
  function openShot(i) { state.shotI = i; $('img', ui.shot).src = state.shots[i].url; ui.shot.hidden = false; }
  function saveShot() {
    var s = state.shots[state.shotI || 0]; if (!s) return;
    fetch(s.url).then(function (r) { return r.blob(); }).then(function (b) {
      var name = 'ecstasy-try-on.jpg', file = new File([b], name, { type: 'image/jpeg' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) return navigator.share({ files: [file], title: D.title });
      var a = document.createElement('a'); a.href = s.url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
    }).catch(function () {});
  }

  function resetGate() {
    ui.gate.hidden = false; ui.root.classList.remove('is-live');
    ui.gate.querySelector('.ecx-to__card').innerHTML =
      '<div class="ecx-to__icon">' + ICON.face + '</div>' +
      '<h3>Try these on your face</h3>' +
      '<p>See the frame on you, at its real size, in a few seconds.</p>' +
      '<ul><li>' + ICON.check + '<span>Runs on your device. Your camera is never recorded, uploaded or stored.</span></li>' +
      '<li>' + ICON.check + '<span>Sized to scale, so you see how wide it really sits.</span></li>' +
      '<li>' + ICON.check + '<span>Switch colours and take photos to compare.</span></li></ul>' +
      '<div class="ecx-to__row"><button type="button" class="ecx-to__btn ecx-to__btn--solid" data-a="cam">' + ICON.cam + 'Use my camera</button>' +
      '<button type="button" class="ecx-to__btn" data-a="upload">' + ICON.up + 'Upload a photo</button></div>' +
      '<div class="ecx-to__err"></div>';
    ui.err = $('.ecx-to__err', ui.gate);
  }
  function stopCamera() { state.running = false; if (state.stream) { state.stream.getTracks().forEach(function (t) { t.stop(); }); state.stream = null; } }

  function open(viewer) {
    if (!ui) build();
    fill();
    ui.root.style.display = 'flex'; requestAnimationFrame(function () { ui.root.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    state.ps = null; state.smooth = new Smooth(); ui.shot.hidden = true;
    pick(state.variant);
    loadVision();                                  // warm up while the visitor reads the gate
    ensure3D();
    if (viewer) return;
    if (store('ecx-to-ok') === '1') startCamera(); else { resetGate(); }
    $('.ecx-to__close', ui.root).focus();
  }
  function close() {
    state.viewing = false; ui.root.classList.remove('is-view');
    stopCamera(); state.mode = 'camera'; state.photoImg = null; state.photoFace = null;
    ui.root.classList.remove('is-open'); document.documentElement.style.overflow = '';
    setTimeout(function () { ui.root.style.display = 'none'; }, 250);
    if (state.opener) state.opener.focus();
  }

  /* ---------- 3D viewer: the rebuilt frame on a turntable, drag to turn ---------- */
  function stopView() { state.viewing = false; ui.root.classList.remove('is-view'); if (G3) G3.clear(); }
  function open3D() {
    open(true);
    state.mode = 'view'; state.viewing = true; ui.gate.hidden = true;
    ui.root.classList.add('is-live', 'is-view'); fitCanvas(); setHint('Drag to turn');
    var V = state.view; V.ry = 0.45; V.rx = 0.14; V.t = 0.6; V.idle = 0;
    var stage = ui.canvas.parentElement;
    if (!stage._drag) {
      stage._drag = 1;
      stage.addEventListener('pointerdown', function (e) { if (!state.viewing) return; V.drag = { x: e.clientX, y: e.clientY, ry: V.ry, rx: V.rx }; stage.setPointerCapture && stage.setPointerCapture(e.pointerId); setHint(''); });
      stage.addEventListener('pointermove', function (e) { if (!V.drag) return; V.ry = Math.max(-1.25, Math.min(1.25, V.drag.ry + (e.clientX - V.drag.x) * 0.008)); V.rx = Math.max(-0.25, Math.min(0.3, V.drag.rx + (e.clientY - V.drag.y) * 0.003)); V.idle = performance.now(); });
      ['pointerup', 'pointercancel'].forEach(function (n) { stage.addEventListener(n, function () { V.drag = null; V.idle = performance.now(); }); });
    }
    ensure3D().then(function (g) {
      if (!g) { setHint('3D isn’t supported on this device'); return; }
      (function tick() {
        if (!state.viewing) return;
        var c = ui.canvas, ctx = ui.ctx;
        var gr = ctx.createLinearGradient(0, 0, 0, c.height); gr.addColorStop(0, '#F4F8F2'); gr.addColorStop(1, '#EAEEF3');
        ctx.fillStyle = gr; ctx.fillRect(0, 0, c.width, c.height);
        if (state.frame) {
          if (!V.drag && performance.now() - V.idle > 2500) { V.t = (V.t || 0) + 0.012; V.ry += (Math.sin(V.t) * 0.75 - V.ry) * 0.04; }
          if (!(D.model && g.buildModel(D.model, frameSize(), 0, state.adj, state.frame))) g.build(state.frame, frameSize(), 0, state.adj);
          g.spin(V.ry, V.rx);
        }
        requestAnimationFrame(tick);
      })();
    });
  }

  /* ---------- entry point on the product page ---------- */
  function gallery() { var l = document.querySelectorAll('.bls__product-gallery:not(.bls__swiper-gallery-thumbnails)'); for (var i = 0; i < l.length; i++) if (l[i].offsetWidth > 0) return l[i]; return null; }
  function addButton() {
    if (!D || !D.images || !D.images.length) return true;
    if (!D.model) return true;                     // only frames that already have a real 3D model get Try on / 3D
    D.page = true;
    if (document.querySelector('.ecx-tryon-btn')) return true;
    var g = gallery(); if (!g) return false;
    if (getComputedStyle(g).position === 'static') g.style.position = 'relative';
    var b = el('button', 'ecx-tryon-btn', '<span class="dot" aria-hidden="true"></span>' + ICON.face + '<span>Try on</span>');
    b.type = 'button'; b.setAttribute('aria-label', 'Try these frames on with your camera');
    b.style.visibility = 'hidden';
    b.addEventListener('click', function () { D = window.ECX_TRYON; D.page = true; state.variant = state.pageVariant || D.current; state.frame = null; state.opener = b; open(); });
    g.appendChild(b);
    var b3 = el('button', 'ecx-tryon-btn ecx-3d-btn', '<span>3D</span>');
    b3.type = 'button'; b3.setAttribute('aria-label', 'View these frames in 3D'); b3.style.visibility = 'hidden';
    b3.addEventListener('click', function () { D = window.ECX_TRYON; D.page = true; state.variant = state.pageVariant || D.current; state.frame = null; state.opener = b3; open3D(); });
    g.appendChild(b3);
    function place3() { b3.style.setProperty('top', (b.offsetTop + b.offsetHeight + 8) + 'px', 'important'); }
    place3(); window.addEventListener('resize', place3);
    // only show the buttons once we know a front photo exists
    frameFor(D.current).then(function (f) { if (f) { b.style.visibility = ''; b3.style.visibility = ''; place3(); state.frame = f; } else { b.remove(); b3.remove(); } });
    // keep the try-on colour in step with the page's colour picker
    document.addEventListener('change', function (e) {
      var id = +((e.target.closest('form') || {}).querySelector ? (e.target.closest('form').querySelector('[name=id]') || {}).value : 0);
      if (id && window.ECX_TRYON && window.ECX_TRYON.variants.some(function (v) { return v.id === id; })) state.pageVariant = id;
    });
    return true;
  }
  var tries = 0;
  (function t() { if (!addButton() && ++tries < 30) setTimeout(t, 300); })();

  /* ---------- "Try on" on product cards: loads that product, opens the same try-on ---------- */
  var EYE = /glass|sun|goggle|frame|optical|spectacle/i;
  function cardButtons() {
    document.querySelectorAll('.bls__product-item[data-product-handle]:not([data-ecx-to])').forEach(function (c) {
      c.setAttribute('data-ecx-to', '1');
      var t = c.getAttribute('data-ecx-type') || '';
      if (!EYE.test(t) || !c.hasAttribute('data-ecx-3d')) return;   // only frames with a real 3D model
      var media = c.querySelector('.bls__product-img, .bls__product-image, .bls__product-media, .bls__responsive-image') || c.querySelector('a[href*="/products/"]');
      if (!media) return;
      var host = media.closest('.bls__product-img, .bls__product-image, .bls__product-media') || media.parentElement;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      var b = el('button', 'ecx-tryon-card', ICON.face + '<span>Try on</span>');
      b.type = 'button'; b.setAttribute('aria-label', 'Try on ' + (c.querySelector('.bls__product-name, .product-title, h3') || {}).textContent);
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openCard(c.getAttribute('data-product-handle'), b); });
      host.appendChild(b);
      var h = c.getAttribute('data-product-handle');
      c.addEventListener('mouseenter', function () { cardCheck(h).then(function (d) { if (!d) b.remove(); }); }, { once: true });
      c.addEventListener('touchstart', function () { cardCheck(h).then(function (d) { if (!d) b.remove(); }); }, { once: true, passive: true });
    });
  }
  var cardData = {}, cardOk = {};
  function cardProduct(handle) {
    return cardData[handle] || (cardData[handle] = fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      function w(u) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=1200'; }
      var imgs = (p.media || []).filter(function (m) { return m.media_type === 'image'; }).map(function (m) {
        return { src: w(m.src), v: p.variants.filter(function (v) { return v.featured_image && v.featured_image.id === m.id; }).map(function (v) { return v.id; }).concat([0]) };
      });
      var vs = p.variants.map(function (v) { return { id: v.id, t: v.title, img: v.featured_image ? w(v.featured_image.src) : null, a: v.available }; });
      var tmp = document.createElement('div'); tmp.innerHTML = p.description || '';
      var first = vs.filter(function (v) { return v.a; })[0] || vs[0];
      var mdl = (p.media || []).filter(function (m) { return m.media_type === 'model'; })[0], glb = null;
      if (mdl && mdl.sources) mdl.sources.forEach(function (s2) { if (s2.format === 'glb' && !glb) glb = s2.url; });
      return { title: p.title, images: imgs, variants: vs, current: first.id, single: vs.length === 1, size: sizeFrom(tmp.textContent || ''), url: p.url, model: glb };
    }));
  }
  /* does this product have a usable front photo? (checked on hover so the button only stays where try-on works) */
  function cardCheck(handle) {
    return cardOk[handle] || (cardOk[handle] = cardProduct(handle).then(function (d) {
      if (!d.images.length) return null;
      var keep = D; D = d; var pr = frameFor(d.current); D = keep;
      return pr.then(function (f) { return f ? d : null; });
    }));
  }
  function openCard(handle, btn) {
    btn.classList.add('is-busy');
    cardCheck(handle).then(function (d) {
      btn.classList.remove('is-busy');
      if (!d) { btn.remove(); return; }
      D = d; state.variant = d.current; state.frame = null; state.opener = btn; open();
    }).catch(function () { btn.classList.remove('is-busy'); window.location.href = '/products/' + handle; });
  }
  cardButtons();
  new MutationObserver(function () { clearTimeout(cardButtons._t); cardButtons._t = setTimeout(cardButtons, 200); }).observe(document.body, { childList: true, subtree: true });
})();
